import { Box, Flex, Link, Typography } from '@iheartjane/reefer';
import type { LabResultWithTerpene } from '@iheartjane/types';
import { useMemo, useState } from 'react';

import { TerpeneBar } from './terpenes/terpeneBar';

import styles from './topTerpenes.module.css';

interface TopTerpenesProps {
  sortedTerpenes: LabResultWithTerpene[];
}

export const TopTerpenes = ({ sortedTerpenes }: TopTerpenesProps) => {
  const [viewMore, setViewMore] = useState(false);

  const total = useMemo(
    () =>
      (!viewMore ? sortedTerpenes.slice(0, 3) : sortedTerpenes).reduce(
        (prev, curr) => prev + curr.value,
        0
      ),
    [sortedTerpenes, viewMore]
  );

  return (
    <Box className={styles['topTerpenesContainer']}>
      <Flex justifyContent="space-between" width="100%" alignItems="center">
        <Typography variant="body-semibold">Top Terpenes</Typography>
        <Link onClick={() => setViewMore(!viewMore)}>
          View {viewMore ? 'less' : 'more'}
        </Link>
      </Flex>
      <Flex
        flexDirection={!viewMore ? 'row' : 'column'}
        className={styles['terpeneBarContainer']}
      >
        {(viewMore ? sortedTerpenes : sortedTerpenes.slice(0, 3)).map(
          (terpene) => (
            <TerpeneBar
              actualPercentage={terpene.value}
              variant={viewMore ? 'row' : 'column'}
              key={terpene.matchingTerpene}
              widthPercentage={(terpene.value / total) * 100}
              terpene={terpene.matchingTerpene}
              unit={terpene.unit}
            />
          )
        )}
      </Flex>
    </Box>
  );
};
